import { render } from "./Institucional.vue?vue&type=template&id=1141ba7e&scoped=true"
import script from "./Institucional.vue?vue&type=script&lang=js"
export * from "./Institucional.vue?vue&type=script&lang=js"

import "./Institucional.vue?vue&type=style&index=0&id=1141ba7e&lang=scss&scoped=true"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1141ba7e"]])

export default __exports__